import { Panel } from "../../../../components/ui/Panel";
import { Animations } from "../../../util/Animations";
import ModalContext from "../../context/ModalContext";
import { ImpactsGridSidebar } from "./ImpactsGridSidebar/ImpactsGridSidebar_view";

export const SHOW_IMPACTS_GRID_MODAL = (onAssignSuccess: (itemIds: number[]) => any, selectedItems: number[]) => {
  ModalContext.show({
    showClose: false,
    title: null,
    className: "d-flex flex-column",
    panelProps: {
      className: "d-flex flex-column h-100"
    },
    componentProps: {
      wrapHeight: "large",
      wrapWidth: "large",
      position: "middle",
      panelProps: {
        background: Panel.PanelBackgrounds.BG_LIGHT,
        className: "h-auto min-h-100",
        hasShadow: true
      }
    },
    animationOptions: {
      animateIn: Animations.SLIDE_IN_UP,
      animateOut: Animations.SLIDE_OUT_DOWN
    },
    content: (
      <ImpactsGridSidebar
        onAssignSuccess={items => {
          ModalContext.hide();
          onAssignSuccess(items);
        }}
        selectedImpactIds={selectedItems}
      />
    )
  });
};
